import React from "react"
import { FlexContainer } from "../../styled/layout.styled"
import { H4 } from "./Card"
import SectionTopic from "../reuseAble/SectionTopic"
import styled from "@emotion/styled"

const StyledH4 = styled(H4)`
  a {
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    &:hover {
      text-decoration: underline;
    }
  }
`

const DetailsCard = ({ topic, names, link }) => {
  return (
    <FlexContainer
      flexDirection="column"
      width="45%"
      flexWrap="wrap"
      padding="0 0 40px 0"
      miniWidth="60%"
    >
      <SectionTopic topic={topic} />
      {names
        ? names.map(name =>
            link ? (
              <StyledH4 key={name.name}>
                <a href={name.link} target="_blank" rel="noreferrer noopener">
                  {name.name}
                </a>
              </StyledH4>
            ) : (
              <H4 key={name}>{name}</H4>
            )
          )
        : null}
    </FlexContainer>
  )
}

export default DetailsCard
